var _path, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 104,
    viewBox: "0 0 105 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.3026 32.3029C74.2064 30.399 77.2931 30.399 79.1969 32.3029C81.0774 34.1833 81.1004 37.2178 79.2661 39.1266L53.3168 71.5632C53.2793 71.61 53.2393 71.6547 53.1969 71.6971C51.2931 73.601 48.2064 73.601 46.3026 71.6971L29.1007 54.4952C27.1969 52.5914 27.1969 49.5048 29.1007 47.601C31.0045 45.6971 34.0912 45.6971 35.995 47.601L49.6029 61.2088L72.1733 32.4487C72.2135 32.3975 72.2566 32.3488 72.3026 32.3029Z",
    fill: "url(#paint0_linear_1124_811)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2.5,
    width: 99,
    height: 99,
    rx: 49.5,
    stroke: "url(#paint1_linear_1124_811)",
    strokeWidth: 5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1124_811",
    x1: 73.5479,
    y1: 63.3749,
    x2: 32.8018,
    y2: 63.2554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0371462,
    stopColor: "#07BBA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07BB85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1124_811",
    x1: 90.6006,
    y1: 79.9997,
    x2: 10.5733,
    y2: 79.8124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0371462,
    stopColor: "#07BBA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07BB85"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneSign);
export default __webpack_public_path__ + "static/media/doneSign.da46a07e4e7d1157ebe76749e73d1533.svg";
export { ForwardRef as ReactComponent };